import Card from '@mui/material/Card';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import { Box, CardHeader, CardContent, IconButton, Tooltip, Grid, Divider, TextField, Button, Backdrop, CircularProgress, Snackbar } from '@mui/material';
import Alert from 'src/components/Alert';
import AddIcon from '@mui/icons-material/Add';
import { confirmAlert } from 'react-confirm-alert';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

function SarisDynamicProduct() {

  const [dynamicReportData, setDynamicReportData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [productName, setProductName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleGetSarisDynamicProduct();
  }, []);

  const handleGetSarisDynamicProduct = () => {
    setLoading(true);
    axios
      .get(`GetSarisDynamicProduct`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setDynamicReportData(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const deleteDynamicProduct = (UrunKod, KulUrunKod, Acıklama) => {
    confirmAlert({
      message: 'Silmek istediğinizde emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            handleDeleteDynamicProduct(UrunKod, KulUrunKod, Acıklama);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleDeleteDynamicProduct = (UrunKod, KulUrunKod, Acıklama) => {
    setLoading(true);
    const encodedAciklama = Acıklama.toString();
    axios
      .get(
        `SetSarisDynamicProductDelete/${UrunKod}/${KulUrunKod}/${encodedAciklama}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicProduct();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const HandleInsertProduct = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicNewProduct/${productName}/${description}`)
      .then(response => {
        var data = response.data;
        setLoading(false);
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          HandleResertAndClose();
          handleGetSarisDynamicProduct();
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function HandleResertAndClose() {
    setProductName('');
    setDescription('');
  }

  const columns = [
    {
      field: 'KUL_URUN_KODU',
      headerName: 'Ürün',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 400,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'KUL_KODU',
      headerName: 'Sistem Kodu',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ADSOYAD',
      headerName: 'Kullanıcı',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    {
      field: 'Sil',
      headerName: '',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: cellValues => {
        return (
          <Tooltip title="Sil">
            <IconButton
              size="small"
              onClick={() =>
                deleteDynamicProduct(
                  cellValues?.row?.URUN_KODU.toString(),
                  cellValues?.row?.KUL_URUN_KODU.toString(),
                  cellValues?.row?.ACIKLAMA.toString()
                )
              }
            >
              <DeleteIcon style={{ color: '#FF9800' }} />
            </IconButton>
          </Tooltip>
        );
      },
      width: 80
    }
  ];

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title="Dinamik Ürünler" />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Ürün Adı"
                variant="outlined"
                size="small"
                value={productName}
                onChange={e => setProductName(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Açıklama"
                variant="outlined"
                size="small"
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    HandleInsertProduct();
                  }}
                >
                  Ekle
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3, height: 600, width: '100%' }}>
            <DataGrid
              rows={dynamicReportData}
              columns={columns}
              getRowId={rows => rows.URUN_KODU}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 }
                }
              }}
              pageSizeOptions={[10, 25, 50]}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { placeholder: 'Ara...' }
                }
              }}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  color: 'text.primary'
                },
                '& .MuiDataGrid-cell': {
                  color: 'text.primary'
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicProduct;
